import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";

interface LayouProps {
  children: ReactNode;
}

const Layout = ({ children }: LayouProps) => {
  const location = useLocation();

  // List of routes that should not show Header/Footer
  const noLayoutRoutes = [
    "/events/ai-data-centers-to-accelerate-ce-transitions",
  ];

  const shouldHideLayout = noLayoutRoutes.includes(location.pathname);

  return (
    <>
      {!shouldHideLayout && <Header />}
      {children}
      {!shouldHideLayout && <Footer />}
    </>
  );
};

export default Layout;
